import { t } from 'i18next'
import React from 'react'

function Footer({ training, imprimable, slowTraining }) {



    var asterisks = [t('pdf:footer:mentionIA'),t('pdf:footer:firstAsterisk')];

    if (!training || slowTraining) {
        return;
    }
    var parameterNames = training.insight_items.filter((item) => item.insight_parameter != null).map((item) => item.insight_parameter.name);

    if (parameterNames.includes("insight.max_speed")) {
        asterisks.push(t('pdf:footer:secondAsterisk'));
    }

    if (parameterNames.includes("insight.stride_frequency_at_60")) {
        asterisks.push(t('pdf:footer:thirdAsterisk'));
    }

    return (
        <div style={{ fontSize: "0.575rem", lineHeight: "0.80rem" }} className={` ps-2 pe-2 pt-2 w-full flex text-xs   justify-start   `}>
            <div>
                {asterisks.map((text, index) => (
                    <div> {'*'.repeat(index + 1 ).concat(text)} </div>))}

            </div>
        </div>
    );
}

export default Footer